import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class ExternoService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private dataService: DataService
    ){
    }

    ngOnInit(){}
    pagosPendientesPorSocio(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);

      this.http
      .post(
        Constants.API_BASE + "/externo/pagosPendientesPorSocio",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/externo/externo.service.ts